// extracted by mini-css-extract-plugin
module.exports = {"container":"ClaimCaseScreen_container__2KbOL","topBar":"ClaimCaseScreen_topBar__U8JYG","titleHeader":"ClaimCaseScreen_titleHeader__swFh7"};